import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/atoms/Tabs';
import { useLog } from '@/hooks/V3/useLog';
import { useAppSelector } from '@/redux/store';
import { deviceUuidState } from '@/store/atom';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useMembershipPreviewMode } from '@/components/membership/MembershipContentLock';
import { membershipDashboardMock } from '../membership-dashboard-mock';
import { DashboardCard } from '../card';
import ChangeNameDashboard from './ChangeNameDashboard';
import MakeNameDashboard from './MakeNameDashboard';

const tabKeys = ['makeName', 'changeName'] as const;
type TabKey = (typeof tabKeys)[number];

const SellerboxAi = () => {
  const isPreviewMode = useMembershipPreviewMode();
  const [activeTab, setActiveTab] = useState<TabKey>('makeName');

  const { UserNo } = useAppSelector((state) => state.user);
  const { setUserEventHistory } = useLog(UserNo);
  const deviceUuid = useRecoilValue(deviceUuidState);

  const handleTabChange = (val: string) => {
    const newTab = val as TabKey;
    setActiveTab(newTab);

    if (isPreviewMode) return;

    // 탭 전환 로그 이벤트
    setUserEventHistory({
      eventName: 'ai_tab_change_web_dashboard',
      eventValue: newTab,
      deviceUuid,
    });
  };

  const makeNamePreviewData = isPreviewMode
    ? membershipDashboardMock.sellerboxAi.makeName
    : undefined;
  const changeNamePreviewData = isPreviewMode
    ? membershipDashboardMock.sellerboxAi.changeName
    : undefined;

  return (
    <DashboardCard>
      <div className="text-gr-900 Body1S16">Sellerbox AI</div>
      <Tabs
        defaultValue={activeTab}
        value={activeTab}
        onValueChange={handleTabChange}
        className="w-full space-y-5"
      >
        <TabsList className=" w-fit">
          <TabsTrigger
            value="makeName"
            data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
          >
            상품명 제작
          </TabsTrigger>
          <TabsTrigger
            value="changeName"
            data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
          >
            도매몰 상품명 변경
          </TabsTrigger>
        </TabsList>
        {activeTab === 'makeName' && (
          <TabsContent value="makeName" forceMount>
            <MakeNameDashboard activeTab={activeTab} previewData={makeNamePreviewData} />
          </TabsContent>
        )}
        {activeTab === 'changeName' && (
          <TabsContent value="changeName" forceMount>
            <ChangeNameDashboard activeTab={activeTab} previewData={changeNamePreviewData} />
          </TabsContent>
        )}
      </Tabs>
    </DashboardCard>
  );
};

export default SellerboxAi;
